<div class="link-expired-overlay">
  <div class="link-expired-card">
    <div class="link-expired-card__illustration">
      <img src="assets/images/session-expired.png" alt="Link expired" />
    </div>

    <div class="link-expired-card__content">
      <h1 class="link-expired-card__title">Link Expired</h1>
      <p class="link-expired-card__description">
        For security reasons, this link is no longer valid as its validity period has ended. Please request a new link to regain access and continue.
      </p>
    </div>
  </div>
</div>
